import './Loading.css';

const Loading = () => {
  return (
    <div className="loader-container">
      <p className="dot-loader">Loading<span>.</span><span>.</span><span>.</span></p>
    </div>
  );
};

export default Loading;